import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  project_categories: [],
  project_category_groups: [],
  current_project_category: {},
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
